"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceEstimateBulkResponseToJSON = exports.AudienceEstimateBulkResponseFromJSONTyped = exports.AudienceEstimateBulkResponseFromJSON = exports.instanceOfAudienceEstimateBulkResponse = void 0;
var runtime_1 = require("../runtime");
var FixedCostAudienceSizeResponse_1 = require("./FixedCostAudienceSizeResponse");
/**
 * Check if a given object implements the AudienceEstimateBulkResponse interface.
 */
function instanceOfAudienceEstimateBulkResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceEstimateBulkResponse = instanceOfAudienceEstimateBulkResponse;
function AudienceEstimateBulkResponseFromJSON(json) {
    return AudienceEstimateBulkResponseFromJSONTyped(json, false);
}
exports.AudienceEstimateBulkResponseFromJSON = AudienceEstimateBulkResponseFromJSON;
function AudienceEstimateBulkResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audienceSizeResponse': !(0, runtime_1.exists)(json, 'audience_size_response') ? undefined : (json['audience_size_response'].map(FixedCostAudienceSizeResponse_1.FixedCostAudienceSizeResponseFromJSON)),
    };
}
exports.AudienceEstimateBulkResponseFromJSONTyped = AudienceEstimateBulkResponseFromJSONTyped;
function AudienceEstimateBulkResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audience_size_response': value.audienceSizeResponse === undefined ? undefined : (value.audienceSizeResponse.map(FixedCostAudienceSizeResponse_1.FixedCostAudienceSizeResponseToJSON)),
    };
}
exports.AudienceEstimateBulkResponseToJSON = AudienceEstimateBulkResponseToJSON;
